import React from 'react';
import { Upload } from 'lucide-react';

/**
 * Upload section component for custom book cover uploads
 */
const UploadSection = ({ uploadedImage, setUploadedImage }) => {
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white rounded-3xl shadow-xl p-8">
      <h3 className="text-2xl font-bold text-center mb-6 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
        📸 Can't Find Your Book?
      </h3>
      <p className="text-center text-gray-600 mb-6">Upload a picture of the book cover and we'll help you order it!</p>
      
      <div className="border-2 border-dashed border-purple-300 rounded-2xl p-8 text-center hover:border-purple-400 transition-colors">
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="hidden"
          id="image-upload"
        />
        <label htmlFor="image-upload" className="cursor-pointer">
          {uploadedImage ? (
            <div className="space-y-4">
              <img src={uploadedImage} alt="Uploaded cover" className="max-w-32 mx-auto rounded-lg shadow-lg" />
              <p className="text-green-600 font-semibold">✨ Perfect! Image uploaded successfully</p>
              <p className="text-sm text-gray-500">Click to change image</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="bg-gradient-to-r from-purple-100 to-blue-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto">
                <Upload className="w-10 h-10 text-purple-600" />
              </div>
              <div>
                <p className="text-lg font-semibold text-gray-700">Drop your book cover here</p>
                <p className="text-gray-500">or click to browse</p>
              </div>
            </div>
          )}
        </label>
      </div>
    </div>
  );
};

export default UploadSection;
